import(/* webpackMode: "eager" */ "C:\\Users\\skole\\Documents\\WebDev\\bedriftsabonnement24.no_v0\\app\\page.tsx");
